import React from 'react';
import { useTranslation } from 'react-i18next';
import { isSafeGetRetry } from '../api';
import { resolveUserFacingError } from '../utils/actionFeedback';
import {
  Alert, Box, Button, CircularProgress, Typography,
} from '@mui/material';

export default function DataState({ loading, error, onRetry, loadingLabel, errorMessage }) {
  const { t } = useTranslation();

  if (error) {
    return (
      <Alert
        severity="error"
        action={onRetry && isSafeGetRetry(error) && (
          <Button color="inherit" size="small" onClick={onRetry}>{t('common.retry')}</Button>
        )}
      >
        {resolveUserFacingError(
          error,
          errorMessage || t('common.error.loadData'),
        )}
      </Alert>
    );
  }

  if (!loading) return null;

  return (
    <Box
      sx={{
        display: 'none', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', gap: 1.5, py: 6, color: 'text.secondary',
      }}
    >
      <CircularProgress size={26} />
      <Typography variant="caption">{loadingLabel || t('common.loading')}</Typography>
    </Box>
  );
}
